import {
	type IRevenueAgencyDropDown
} from '../../types'

export const revenueAgencyOptionValue = (_: IRevenueAgencyDropDown) => {
	return `${_.id}`
}

export const revenueAgencyOptionLabel = (_: IRevenueAgencyDropDown) => {
	return `[id: ${_.id}] ${_.name}`
}

export const revenueAgencyFormatOptionLabel = (_: IRevenueAgencyDropDown) => {
	return <>
		[<strong>id: {_.id}</strong>]
		&nbsp;
		{_.name}
	</>
}
